import { flow } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';
import { disconnectUserIntegration, fetchActiveUserIntegration } from '../../../API/userIntegrationsAPI';
import { defaults } from '../index';
const Actions = self => ({
    resetFreeCredits: () => {
        self.freeCredits = '';
    },
    setShowSuccessConnection: val => {
        self.showConnectionSuccess = val;
    },
    login: flow(function* login(freeCredits = '') {
        var _a;
        self.uuid = uuid();
        self.timestamp = parseInt(Date.now() / 1000, 0);
        const userIntegration = (yield fetchActiveUserIntegration()) || defaults;
        self.id = userIntegration.id;
        self.integration = userIntegration.integration.name;
        self.integrationId = userIntegration.integrationId;
        self.freeCredits = freeCredits;
        let { token } = defaults;
        if (userIntegration.tokens) {
            const latest = new Date(Math.max.apply(null, userIntegration.tokens.map(tokenItem => new Date(tokenItem.updatedAt))));
            token = userIntegration.tokens.find(tokenItem => {
                const updatedAt = new Date(tokenItem.updatedAt);
                return updatedAt.getTime() === latest.getTime();
            });
        }
        const isSendScopeAvailable = (((_a = token === null || token === void 0 ? void 0 : token.tokenScopes) === null || _a === void 0 ? void 0 : _a.split(',')) || []).includes('EMAIL_SEND');
        self.isSendScopeAvailable = !!isSendScopeAvailable;
        if (token) {
            self.email = token.email;
        }
    }),
    logout: flow(function* logout() {
        if (self.id) {
            yield disconnectUserIntegration(self.id);
            self.id = defaults.id;
            self.integration = defaults.integration.name;
            self.integrationId = defaults.integrationId;
            self.email = defaults.token.email;
            self.freeCredits = '';
            self.addressee = '';
        }
    }),
    disableJoinToCommunityForSession: () => {
        self.shouldAskUserToJoinCommunity = false;
    },
});
export default Actions;
